<div class="gw-flex gw-flex-col gw-gap-medium gw-h-full gw-min-h-0">
  <div
    class="gw-flex gw-flex-col gw-items-center gw-justify-center gw-gap-small gw-mb-small"
  >
    <tui-avatar
      class="gw-h-[52px] gw-w-[52px] gw-shrink-0 gw-border-base-neutral gw-bg-background-elevation-2"
      [round]="true"
      [src]="confirmedAvatarInitialsSource | tuiInitials"
      [style.color]="'var(--tui-background-accent-1)'"
      [style.fontWeight]="'bold'"
    ></tui-avatar>

    <span
      class="gw-text-center gw-text-text-primary gw-font-extrabold gw-uppercase gw-leading-snug gw-line-clamp-3"
      >{{ resolvedRecipientName }}</span
    >
  </div>

  <div
    class="gw-flex gw-min-h-0 gw-flex-1 gw-flex-col gw-rounded-xl gw-border gw-border-border-normal gw-bg-background-elevation-2 gw-p-medium"
  >
    <div
      class="gw-flex gw-items-center gw-gap-small gw-border-b gw-border-border-normal gw-pb-medium"
    >
      <div
        class="gw-flex gw-h-10 gw-w-10 gw-shrink-0 gw-items-center gw-justify-center gw-overflow-hidden gw-rounded-full gw-bg-background-neutral-1 gw-text-base gw-font-bold gw-text-text-primary"
        aria-hidden="true"
      >
        <gatewee-bank-svg-logo
          class="gw-flex gw-h-full gw-w-full gw-items-center gw-justify-center gw-text-base gw-font-bold gw-text-text-primary"
          [compeCode]="pixRecipientResponse?.compeCode"
          format="circle"
          [size]="40"
        >
          {{ confirmedBankBadgeLetter }}
        </gatewee-bank-svg-logo>
      </div>
      <span
        class="gw-min-w-0 gw-flex-1 gw-break-words gw-font-extrabold gw-leading-snug gw-text-text-primary"
        >{{ confirmedBankDisplayLine | uppercase }}</span
      >
    </div>

    <div
      class="gw-flex gw-items-start gw-gap-small gw-border-b gw-border-border-normal gw-py-medium"
    >
      <div
        class="gw-flex gw-h-10 gw-w-10 gw-shrink-0 gw-items-center gw-justify-center gw-rounded-full gw-bg-background-neutral-1"
        aria-hidden="true"
      >
        <gatewee-icon
          icon="@phi.pix-logo"
          iconStyle="primary"
          size="22px"
        ></gatewee-icon>
      </div>
      <div class="gw-min-w-0 gw-flex-1 gw-flex gw-flex-col gw-gap-1">
        <ng-container [ngSwitch]="confirmedPixKeyDisplayMode">
          <span
            *ngSwitchCase="'phone'"
            class="gw-break-all gw-font-extrabold gw-leading-snug gw-text-text-primary"
            >{{ confirmedPixKeyDigitsForPipe | phone }}</span
          >
          <span
            *ngSwitchCase="'document'"
            class="gw-break-all gw-font-extrabold gw-leading-snug gw-text-text-primary"
            >{{ confirmedPixKeyDigitsForPipe | document }}</span
          >
          <span
            *ngSwitchDefault
            class="gw-break-all gw-font-extrabold gw-leading-snug gw-text-text-primary"
            >{{ confirmedPixKeyLine }}</span
          >
        </ng-container>
        <span
          *ngIf="confirmedPixKeyTypeTranslationKey as typeKey"
          class="gw-text-xs gw-font-normal gw-leading-snug gw-text-text-secondary"
          >{{ typeKey | translate }}</span
        >
        <span
          *ngIf="
            !confirmedPixKeyTypeTranslationKey && confirmedPixKeyDisplay.trim()
          "
          class="gw-text-xs gw-font-medium gw-leading-snug gw-text-text-secondary"
          >{{
            'features.withdrawals.modalPix.labelUnknownKeyType' | translate
          }}</span
        >
      </div>
    </div>

    <div
      *ngIf="hasConfirmedRecipientBankDetails"
      class="gw-flex gw-flex-col gw-gap-medium gw-border-b gw-border-border-normal gw-py-medium"
    >
      <div
        *ngIf="(pixRecipientResponse?.holderDocument ?? '').toString().trim()"
        class="gw-flex gw-items-center gw-justify-between gw-gap-small"
      >
        <span class="gw-min-w-0 gw-text-text-primary gw-font-bold">{{
          'features.withdrawals.modalPix.cpfCnpj' | translate
        }}</span>
        <span
          class="gw-shrink-0 gw-text-right gw-text-text-secondary gw-font-normal"
          >{{ pixRecipientResponse?.holderDocument | document }}</span
        >
      </div>
      <div
        *ngIf="(pixRecipientResponse?.agency ?? '').toString().trim()"
        class="gw-flex gw-items-center gw-justify-between gw-gap-small"
      >
        <span class="gw-min-w-0 gw-text-text-primary gw-font-bold">{{
          'features.withdrawals.modalPix.agency' | translate
        }}</span>
        <span
          class="gw-shrink-0 gw-text-right gw-text-text-secondary gw-font-normal"
          >{{ formatAgency(pixRecipientResponse?.agency) }}</span
        >
      </div>
      <div
        *ngIf="(pixRecipientResponse?.account ?? '').toString().trim()"
        class="gw-flex gw-items-center gw-justify-between gw-gap-small"
      >
        <span class="gw-min-w-0 gw-text-text-primary gw-font-bold">{{
          'features.withdrawals.modalPix.checkingAccount' | translate
        }}</span>
        <span
          class="gw-shrink-0 gw-text-right gw-text-text-secondary gw-font-normal"
          >{{ formatAccount(pixRecipientResponse?.account) }}</span
        >
      </div>
    </div>

    <div
      class="gw-flex gw-items-center gw-justify-between gw-gap-small gw-pt-medium gw-opacity-70"
      aria-disabled="true"
    >
      <span class="gw-font-medium gw-text-text-primary">{{
        'features.withdrawals.modalPix.saveContact' | translate
      }}</span>
      <span
        class="gw-shrink-0 gw-text-xs gw-font-medium gw-uppercase gw-tracking-wide gw-text-text-tertiary"
        >{{
          'features.withdrawals.modalPix.saveContactComingSoon' | translate
        }}</span
      >
    </div>
  </div>
</div>
